export default __webpack_public_path__ + "images/D9.6cf2080.png";